import {
  signIn,
  signOut,
  getCurrentUser as amplifyGetCurrentUser,
} from "aws-amplify/auth";
import config from "../config";

export async function login(email, password) {
  await signIn({ username: email, password }).catch((e) =>
    console.log("Error: ", e)
  );
}

export async function logout() {
  try {
    // clear local user session

    await signOut();
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

function getCookieValue(name) {
  for (const cookie of document.cookie.split(";")) {
    const separator = cookie.indexOf("=");
    if (separator < 0) continue;
    try {
      if (decodeURIComponent(cookie.slice(0, separator).trim()) === name) {
        return decodeURIComponent(cookie.slice(separator + 1));
      }
    } catch {
      // An unrelated malformed cookie must not invalidate the active session.
    }
  }
  return null;
}

function getActiveTokenExpiration(tokenType) {
  try {
    const prefix = `CognitoIdentityServiceProvider.${config.cognito.APP_CLIENT_ID}.`;
    const user = getCookieValue(`${prefix}LastAuthUser`);
    if (!user) return null;
    const token = getCookieValue(`${prefix}${user}.${tokenType}`);
    if (!token) return null;
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(payload));
    return Number.isFinite(exp) ? exp : null;
  } catch {
    return null;
  }
}

export function getCurrentUser() {
  const now = Date.now() / 1000;
  const accessExp = getActiveTokenExpiration("accessToken");
  const idExp = getActiveTokenExpiration("idToken");
  return accessExp > now && idExp > now;
}

export function getTokenExpiration() {
  return getActiveTokenExpiration("accessToken");
}

export async function getUserName() {
  try {
    // First try to get from Amplify (works in dev with Cognito)
    const cognitoUser = await amplifyGetCurrentUser();
    if (cognitoUser?.username) {
      return cognitoUser.username;
    }
  } catch (error) {
    console.log(
      "Amplify getCurrentUser failed, trying cookie fallback:",
      error
    );
  }

  // Fallback: Extract username from cookies (production SSO)
  try {
    const cookies = document.cookie;
    const cookieArray = cookies.split("; ");

    for (let cookie of cookieArray) {
      const [name, value] = cookie.split("=");
      // Look for common username patterns in SSO cookies
      if (
        name &&
        (name.toLowerCase().includes("user") ||
          name.toLowerCase().includes("email") ||
          name.toLowerCase().includes("name"))
      ) {
        const decodedValue = decodeURIComponent(value);
        if (decodedValue && decodedValue !== "") {
          return decodedValue;
        }
      }
    }
  } catch (cookieError) {
    console.log("Cookie fallback failed:", cookieError);
  }

  return "";
}

const services = {
  login,
  logout,
  getCurrentUser,
  getTokenExpiration,
  getUserName,
};
export default services;
